import { QueryClient } from 'react-query';
import { LoaderFunction, redirect } from 'react-router-dom';
import { isAuthenticated } from 'src/stores/auth';

export const accountIndexLoader: (queryClient: QueryClient) => LoaderFunction =
  () => async () => {
    if (!isAuthenticated()) return redirect('/login');
    return null;
  };
